import React from 'react';
import { useTranslation } from 'react-i18next'; 
import imagemHome_en from '../../assets/home_en.png';
import imagemHome_pt from '../../assets/home_pt.png';
import '../Home/Home.css'

function Home() {
  const { t, i18n } = useTranslation();

  return (
    <div className='home-page-wrapper'>
      <div className='text-container'>
        <h2 className='title-home'>{t('title-home')}</h2>
        
        <p>{t('text-home-1')}</p>
        
        <h2 className='title-home'>{t('text-home-2')}</h2>
        <p>{t('text-home-3')}</p>
        
        <h2 className='title-home'>{t('text-home-4')}</h2>
        <p>{t('structure-home')}</p>
        
        <h2 className='title-home'>{t('text-home-5')}</h2>
        <p>{t('text-home-7')}</p>
        
        <img 
          className='imagem-centralizada' 
          src={i18n.language === 'en' ? imagemHome_en : imagemHome_pt} 
          alt={t('sector-home')} 
        />

       
        <p><strong>{t('text-home-8-title')}</strong>{t('text-home-8-desc')}</p>
        <p><strong>{t('text-home-9-title')}</strong>{t('text-home-9-desc')}</p>
        <p><strong>{t('text-home-10-title')}</strong>{t('text-home-10-desc')}</p>
        

        <h2 className='title-home'>{t('sector-home')}</h2>
        <p className='no-indent'>{t('text-home-16')}</p>
        
        <ul className='sectors-list'>
          <li><strong>{t('residues')}:</strong> {t('desc-residues')}</li>
          <li><strong>{t('waterSanitation')}:</strong> {t('desc-water')}</li>
          <li><strong>{t('agricultureFood')}:</strong> {t('desc-agriculture')}</li>
          <li><strong>{t('mobilityTransportation')}:</strong> {t('desc-mobility')}</li>
          <li><strong>{t('localProductionIndustry')}:</strong> {t('desc-production')}</li>
          <li><strong>{t('constructionInfrastructure')}:</strong> {t('desc-space')}</li>
          <li><strong>{t('energy')}:</strong> {t('desc-energy')}</li>
        </ul>
      </div>
    </div>
  );
}

export default Home;